<template>
    <ul class="navbar-nav ml-auto">
        <!--
        <li class="nav-item">
            <span class="nav-link color-white">Available on:</span>
        </li>
        -->
        <li class="nav-item">
            <a :href="$root.app_link.alexa" target="_blank" class="nav-link"><i class="fab mr-2 fa-amazon"></i>Alexa</a>
            <!--<router-link class="nav-link" to="/alexa"><i class="fab mr-2 fa-amazon"></i>Alexa</router-link>-->
        </li>
        <li class="nav-item">
            <a :href="$root.app_link.android" target="_blank" class="nav-link"><i class="fab mr-2 fa-android"></i>Android</a>
            <!--<router-link class="nav-link" to="/android"><i class="fab mr-2 fa-android"></i>Android</router-link>-->
        </li>
        <li class="nav-item">
            <a :href="$root.app_link.ios" target="_blank" class="nav-link"><i class="fab mr-2 fa-apple"></i>iPhone</a>
            <!--<router-link class="nav-link" to="/ios"><i class="fab mr-2 fa-apple"></i>iPhone</router-link>-->
        </li>
        <li class="nav-item">
            <a :href="$root.app_link.firetv" target="_blank" class="nav-link"><i class="fas mr-2 fa-tv"></i>Fire TV</a>
            <!--<router-link class="nav-link" to="/firetv"><i class="fas mr-2 fa-tv"></i>Fire TV</router-link>-->
        </li>
        <!--
        <li class="nav-item d-none d-lg-block">
            <a href="https://www.producthunt.com/posts/sleep-jar?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-sleep&#0045;jar" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=369218&theme=neutral" alt="Sleep&#0032;Jar - Sleep&#0032;sounds&#0044;&#0032;stories&#0044;&#0032;and&#0032;meditations&#0032;for&#0032;mental&#0032;wellness | Product Hunt" style="width: 200px; height: 40px;" width="200" height="40" /></a>
        </li>
        -->
   </ul>
</template>

<script>
    export default {
        props: [],
        data () {
            return {
            }
        },
        computed: {
        }
    }
</script>
